let usage = `
  <OwlSlider>
    <div class="img-wrapper">
      <img src="https://upload.wikimedia.org/wikipedia/commons/e/e9/2016_BMW_i8.jpg" />
    </div>
    <div class="img-wrapper">
      <img src="https://images.autotrader.com/real-world/225938.jpg" />
    </div>
    <div class="img-wrapper">
      <img src="https://topgearrussia.ru/image-3a6c67d51529094657-640x400.jpg" />
    </div>
  </OwlSlider>
`;

export default {
  usage
};
